module.exports = __webpack_public_path__ + "img/lens-orb-small.62e780d3.png";